// Generated by ReScript, PLEASE EDIT WITH CARE


function getDisplayName(surgeStrategy) {
  if (surgeStrategy.TAG === /* Flat */0) {
    return "Flat";
  } else {
    return "Multiplier";
  }
}

function getListOfStrategyTypes(param) {
  return {
          hd: "Negative Flat",
          tl: {
            hd: "Positive Flat",
            tl: {
              hd: "Negative Multiplier",
              tl: {
                hd: "Positive Multiplier",
                tl: /* [] */0
              }
            }
          }
        };
}

export {
  getDisplayName ,
  getListOfStrategyTypes ,
  
}
/* No side effect */
